import React from 'react';
import * as S from './styles';

type OwnProps = {
  campaignStyling?: {
    background: string;
    text: string;
    name: string;
  } | null;
};

const CampaignBadge = ({ campaignStyling }: OwnProps) => {
  if (!campaignStyling) return null;

  const icon = (
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="17">
      <g fill="none" fillRule="evenodd">
        <path
          fill="#FFF"
          d="M12.23 4.94l-7.606 7.606-.707-.707 7.606-7.606.707.707zm-.317 4.68a1.846 1.846 0 11-2.609 2.609 1.846 1.846 0 012.609-2.609zm-5.07-5.07a1.846 1.846 0 11-2.611 2.609A1.846 1.846 0 016.843 4.55zm4.363 5.778a.845.845 0 10-1.195 1.195.845.845 0 001.195-1.195zm-5.07-5.07a.845.845 0 10-.001 1.194.845.845 0 000-1.195z"
        />
        <path d="M0 .562h16v16H0z" />
      </g>
    </svg>
  );

  return (
    <S.CampaignBadge campaignStyling={campaignStyling}>
      {icon} {campaignStyling.name}
    </S.CampaignBadge>
  );
};

export default CampaignBadge;
